export default "__VITE_ASSET__BlAKd18F__"